import React, { useState, forwardRef } from 'react'
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import classnames from 'classnames'
import SourceCountrySummaryTab from './SourceCountrySummaryTab'
import SourceCountrySecondTab from './SourceCountrySecondTab'
import SourceCountryThirdTab from './SourceCountryThirdTab'
import { useTranslation } from 'react-i18next'

const SourceCountryTabs = forwardRef(({
  isMonthly,
  summaryViewSearchHandlerRef,
  tableImportMonthRef,
  tableImportYearRef
}, ref) => {
  const { t } = useTranslation()
  const [activeInnerTab, setActiveInnerTab] = useState('1')

  return (
    <>
      <Nav tabs className="nav-tabs-s2">
        <NavItem>
          <NavLink
            className={classnames('btn btn-sm', { active: activeInnerTab === '1' })}
            onClick={() => setActiveInnerTab('1')}
          >
            {t('worldTabs.firstTabName')}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames('btn btn-sm', { active: activeInnerTab === '2' })}
            onClick={() => setActiveInnerTab('2')}
          >
            {t('worldTabs.secondTabName')}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames('btn btn-sm', { active: activeInnerTab === '3' })}
            onClick={() => setActiveInnerTab('3')}
          >
            {t('worldTabs.thirdTabName')}
          </NavLink>
        </NavItem>
      </Nav>

      <TabContent activeTab={activeInnerTab} className="mt-3">
        <TabPane tabId="1">
          <SourceCountrySummaryTab
            isMonthly={isMonthly}
            summaryViewSearchHandlerRef={summaryViewSearchHandlerRef}
            tableImportMonthRef={tableImportMonthRef}
            tableImportYearRef={tableImportYearRef}
          />
        </TabPane>

        <TabPane tabId="2">
          <SourceCountrySecondTab isMonthly={isMonthly}/>
        </TabPane>

        <TabPane tabId="3">
          <SourceCountryThirdTab isMonthly={isMonthly}/>
        </TabPane>
      </TabContent>
    </>
  )
})

export default SourceCountryTabs
